export const questions: Array<[string, string]> = [
  [
    'Professional level?',
    'Battery technicians, engineers, renewable energy specialists, BESS professionals, electrical technicians, industrial professionals worldwide.',
  ],
  [
    'Content depth?',
    'From battery fundamentals through advanced management systems, grid integration, safety, lifecycle management, and sustainability. Scales from foundational to professional expertise.',
  ],
  ['International?', 'Yes. Universal battery technology principles with guidance for regional electrical codes and standards.'],
  ['Editable?', 'Yes. Professional-grade PDFs for reference and technical documentation.'],
  ['Currency?', 'USD. Auto-converts to your local currency.'],
  [
    'What makes it different?',
    'Complete system: 6 coherent volumes, 5 exclusive bonuses, 200 essential terms, performance specifications reference, 20 application scenarios, 75 misconceptions clarified, 12 industry applications. Everything designed so you never struggle with technical understanding again.',
  ],
  ['Not satisfied?', '7-day refund. 100% money back, no questions.'],
];
